import Drawer from 'components/common/Drawer';
import SizeBox from 'components/common/SizeBox';
import RibbonSteps from 'features/pii/components/RibbonSteps';
import withVerificationUploadDocumentsDrawerInitial from 'features/uploadDocuments/HOCs/withVerificationUploadDocumentsDrawerInitial';
import { useDetectDevice } from 'hooks/useDetectDevice';
import useLang from 'hooks/useLang';
import React, { useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import VerificationUploadDocumentsDetails from '../VerificationUploadDocumentsDetails';

const DrawerExt = withVerificationUploadDocumentsDrawerInitial(Drawer);

const VerificationUploadDocumentsDrawer = ({ NavBarToggle, onClose, ref }) => {
  const { t } = useLang();
  const { isDesktop } = useDetectDevice();

  const [currentStep, setCurrentStep] = useState(0);

  const drawerRef = useRef();

  const handleOnToggleNavbar = () => {
    drawerRef?.current?.handleOnToggleNavbar();
  };
  useImperativeHandle(ref, () => ({
    isShowNavbar: ref?.current?.isShowNavbar,
    handleOnToggleNavbar,
  }));

  const renderUploadDocumentsStep = () => {
    return (
      <>
        <SizeBox height={5} />
        <RibbonSteps
          currentStep={currentStep}
          stepLabels={[
            t('label_upload_documents_id_document'),
            t('label_upload_documents_selfie_document'),
          ]}
        />
        <SizeBox height={20} />
        <VerificationUploadDocumentsDetails
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          onToggleDrawer={handleOnToggleNavbar}
        />
      </>
    );
  };

  const renderBodyDrawerContent = () => {
    return <>{renderUploadDocumentsStep()}</>;
  };

  return (
    <DrawerExt
      ref={drawerRef}
      NavBarToggle={NavBarToggle}
      ContentBody={
        <ContentBodyStyled>{renderBodyDrawerContent()}</ContentBodyStyled>
      }
      onClose={onClose}
      navTitle={t('button_upload_documents')}
      drawerOffcanvasStyle={{
        width: isDesktop ? '430px!important' : '100%!important',
      }}
      handleOnToggleNavbar={handleOnToggleNavbar}
    />
  );
};

const ContentBodyStyled = styled.div`
  padding: 0;
  border: none;
  width: 100%;
  min-height: 44px;
  height: 100%;
  background: #fff;
`;

export default VerificationUploadDocumentsDrawer;
